import { Box, LinearProgress, Typography} from "@mui/material";

export default function SellPercent({ percent, boldInfo, recette, label, info }) {
    const linearProgressSx = {
        borderRadius: 5,
        '& .MuiLinearProgress-bar': {
            borderRadius: 5,
        },
    };

    return(
        !!percent && percent!==0 ? 

        <Box mt={2}>
            <LinearProgress variant="determinate" value={percent} sx={linearProgressSx} />
            <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                <Typography variant="subtitle1">{boldInfo}</Typography>
                <Typography variant="body2">{percent}%</Typography>
            </Box>
            <Typography variant="body2" sx={{}}>{label}</Typography>
            <Typography variant="body2" sx={{fontSize:12}}>{info}</Typography>
        </Box> :

        <Box mt={2}>
            <LinearProgress variant="determinate" value={100} sx={linearProgressSx}/>
            <Typography variant="subtitle1">{recette?.toFixed(2)} €</Typography>
            <Typography variant="body2" sx={{}}>{label}</Typography>
            <Typography variant="body2" sx={{fontSize:12}}>{info}</Typography>
        </Box>
    )
}